import type { ILegacy_FloorPlanDto } from '../../../model';
import type { TYPES_FIELD_NAME as ScreenOrientation_TYPES_FIELD_NAME } from '../../../model/impl/ScreenOrientationDto.private';
import { VALUES_FIELD_BYTEVALUE as ScreenOrientation_FIELD_BYTEVALUE } from '../../../model/impl/ScreenOrientationDto.private';
import type { ITransaction } from '../../../private/db/interface';
import type { DataMap } from './interface';
import Schema from './schema';

const VERSION = 2;

function _isLegacyFloorPlan(floorplan: object): floorplan is ILegacy_FloorPlanDto {
    return 'imageMediumId' in floorplan;
}

export default Object.freeze({
    version: VERSION,
    description: 'Workspace 2.0 support',
    mappingsChanges: Schema(VERSION),
    upgrade: async (transaction: ITransaction) => {
        /* Move IFloorPlanDto to ILegacy_FloorPlanDto (no move support, must add+delete) */
        const allFloorplansLegacy = await transaction.table('IFloorPlanDto').toArray();
        await transaction.table('ILegacy_FloorPlanDto').bulkAdd(allFloorplansLegacy);
        const floorPlanLegacyPrimaryKeys = await transaction
            .table('IFloorPlanDto')
            .toCollection()
            .keys();

        await transaction
            .table('IFloorPlanDto')
            .bulkDelete(floorPlanLegacyPrimaryKeys)
            .catch(error => {
                throw error;
            });

        /* Ignore addition operations */
        /* ICountryDto - add table */
        /* IDeviceAccountDto - add table */
        /* IFloorPlanTourDto - add table */
        /* IFloorPlanTranslationDto - add table */

        /* IMenuItemDto -- add fields */
        /* IMenuItemKeywordDto - add table */
        /* IMenuItemTranslationDto - add table */
        /* IRoleDto - add table */
        /* IScreenOrientationDto - add field byteValue(manual migration) */
        await transaction
            .table('IScreenOrientationDto')
            .toCollection()
            .modify((object: Record<string, unknown>) => {
                const name = (object['name'] as ScreenOrientation_TYPES_FIELD_NAME) ?? 'All';
                object['byteValue'] = ScreenOrientation_FIELD_BYTEVALUE[name];
            })
            .catch(error => {
                throw error;
            });

        /* ISiteDto - add fields */
        /* ISiteObjectDto - add fields */
        /* IStyleDto - add fields */
        /* ITourRelatedSiteObjectDto - add fields */
        /* ITourDto - add fields
        /* ITourSupportedLanguageDto - add fields */
        /* ITourTranslationDto - add fields */
        /* IUserDto - add fields */
        /* ILegacy_FloorPlanDto - add fields */
    },
    preInsertCleanup: (dataIn: DataMap) => {
        const dataOut = { ...dataIn };

        const floorplans = dataOut.IFloorPlanDto;
        const primaryFloorplan = floorplans.at(0);

        /* Move to Legacy interface & remove existing */
        if (floorplans.length > 0 && primaryFloorplan && _isLegacyFloorPlan(primaryFloorplan)) {
            dataOut.ILegacy_FloorPlanDto = floorplans;
            dataOut.IFloorPlanDto = [];
        }

        return dataOut;
    },
});
